import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import BranchSettingsComponent from '../components/BranchSettingsComponent';
import GeneralSettingsComponent from '../components/GeneralSettingsComponent';
import MercadoLibreSettingsComponent from '../components/MercadoLibreSettingsComponent';
import PymoSettingsComponent from '../components/PymoSettingsComponent';
import StockCountSettingsComponent from '../components/StockCountSettingsComponent';
import ReservationSettingsComponent from '../components/ReservationSettingsComponent';
import TablesSettingsComponent from '../components/TablesSettingsComponent';
import FeatureFlagsSettingsComponent from '../components/FeatureFlagsSettingsComponent';
import MembershipPlansSettingsComponent from '../components/MembershipPlansSettingsComponent';
import { validateSession } from '../utils/functions';

class ConfigurationPage extends Component {

	constructor(){
        const cachedRole = Number(localStorage.getItem('role') || 0);
        const queryParams = new URLSearchParams(window.location.search);
        const requestedTab = (queryParams.get('tab') || 'general').toLowerCase();
        super();
        this.state = {
            checked: !!localStorage.getItem('token'),
            role: cachedRole,
            activeTab: ['general', 'branches', 'mercadolibre', 'pymo', 'conteo', 'reservas', 'membresias', 'flags'].includes(requestedTab) ? requestedTab : 'general',
        }
	}

	async componentDidMount() {
        const role = await validateSession(true);
        this.setState({ checked: true, role });
    }

    renderTabs = () => {
        const tabs = [
            { key: 'general', label: 'General' },
            { key: 'branches', label: 'Sucursales' },
            { key: 'mercadolibre', label: 'MercadoLibre' },
            { key: 'pymo', label: 'Pymo' },
            { key: 'conteo', label: 'Conteo' },
            { key: 'reservas', label: 'Reservas' },
            { key: 'membresias', label: 'Membresías' },
            { key: 'flags', label: 'Feature flags' },
        ];

        return (
            <div className="d-flex align-items-center flex-wrap mb-4" style={{ gap: '0.75rem' }}>
                {tabs.map((tab) => {
                    const isActive = this.state.activeTab === tab.key;
                    return (
                        <button
                            key={tab.key}
                            type="button"
                            className={`btn ${isActive ? 'btn-primary' : 'btn-outline-secondary'}`}
                            onClick={() => this.setState({ activeTab: tab.key }, () => {
                                const queryParams = new URLSearchParams(window.location.search);
                                queryParams.set('tab', tab.key);
                                window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
                            })}
                            style={{ minWidth: '120px' }}
                        >
                            {tab.label}
                        </button>
                    );
                })}
            </div>
        );
    }

    renderContent = () => {
        if (this.state.activeTab === 'branches') {
            return <BranchSettingsComponent />;
        }

        if (this.state.activeTab === 'mercadolibre') {
            return <MercadoLibreSettingsComponent />;
        }

        if (this.state.activeTab === 'pymo') {
            return <PymoSettingsComponent />;
        }

        if (this.state.activeTab === 'conteo') {
            return <StockCountSettingsComponent />;
        }

        if (this.state.activeTab === 'flags') {
            return <FeatureFlagsSettingsComponent role={this.state.role} />;
        }

        if (this.state.activeTab === 'membresias') {
            // Planes de membresía del club (precio y duración). Sólo el admin los edita
            // (enpoints.js: POST/PATCH plans son rol 1); el encargado los ve.
            return <MembershipPlansSettingsComponent />;
        }

        if (this.state.activeTab === 'reservas') {
            // Horario del salón + administración de las mesas (alta/edición/baja).
            return (
                <React.Fragment>
                    <ReservationSettingsComponent />
                    <TablesSettingsComponent />
                </React.Fragment>
            );
        }

        return <GeneralSettingsComponent />;
    }
    
	render() {
        if (!this.state.checked) {
            return (<div></div>);
        } else {
            return (  
                <div className="container-fluid">
                    <div className="row">
                        <SidebarComponent itemSelected={18} role={this.state.role}/>
                        <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                            <NavbarComponent role={this.state.role} />
                            <div className="main-content-container container-fluid px-4 mb-4">
                                <HeaderComponent title="General" subtitle="Configuraciones"/>
                                {this.renderTabs()}
                                {this.renderContent()}
                            </div>
                        </main>
                    </div>
                </div>
            );
        }
    }

}

export default ConfigurationPage;
